<template>
  <div>
    <label for="">{{ label }}</label>
    <v-row>
      <v-col sm="4">
        <v-select v-model="year" :items="getYear" label="Year" :id="compId +'-year'" outlined>
        </v-select>
      </v-col>
      <v-col sm="4">
        <v-select v-model="month" :items="getMonths" label="Month" :id="compId +'-month'" outlined>
        </v-select>
      </v-col>
      <v-col sm="4">
        <v-select v-model="day" :items="getDays" label="Day" :id="compId +'-day'" outlined>
        </v-select>
      </v-col>
    </v-row>
    {{ emitDate }}
  </div>
</template>

<script>
export default {
  data: () => ({
    year: 0,
    month: 0,
    day: 0,
  }),
  props: {
    label: {
      type: String,
      default: "",
    },
    from: {
      type: Number,
      required: false,
    },
    monthProps: {
      type: String,
      required: false,
    },
    dayProps: {
      type: String,
      required: false,
    },
    yearProps: {
      type: String,
      required: false,
    },
    compId:{
      type: String,
      required:false
    }
  },
  computed: {
    getYear() {
      // create year list
      const yearList = [];
      const startYear = this.from || new Date().getFullYear() - 24;
      const endYear = this.from ? startYear + 10 : startYear - 100;
      if (this.from) {
        for (let i = startYear; i <= endYear; i++) {
          yearList.push(i);
        }
      } else {
        for (let i = startYear; i >= endYear; i--) {
          yearList.push(i);
        }
      }

      return yearList;
    },
    getMonths() {
      // create month list
      const monthList = [];
      for (let i = 1; i <= 12; i++) {
        monthList.push(i);
      }
      return monthList;
    },
    getDays() {
      // create day list
      const dayList = [];
      let monthEnd = 31;
      if (this.month === 2) {
        monthEnd = 29;
      } else if (
        this.month === 4 ||
        this.month === 6 ||
        this.month === 9 ||
        this.month === 11
      ) {
        monthEnd = 30;
      }
      for (let i = 1; i <= monthEnd; i++) {
        dayList.push(i);
      }
      return dayList;
    },
    emitDate() {
      if (this.year && this.month && this.day) {
        this.$emit(
          "input",
          `${this.year}-${this.leadingZero(this.month)}-${this.leadingZero(
            this.day
          )}`
        );
      }
      return "";
    },
  },
  methods: {
    leadingZero(num) {
      if (num < 10) {
        return `0${num}`;
      }
      return num;
    },
  },
  mounted() {
    // set default value
    this.day = Number(this.dayProps);
    this.month = Number(this.monthProps);
    this.year = Number(this.yearProps);
  },
  created() {
    // set default value
    this.day = Number(this.dayProps);
    this.month = Number(this.monthProps);
    this.year = Number(this.yearProps);
  },
  watch: {
    yearProps(newVal) {
      this.year = Number(newVal);
    },
    monthProps(newVal) {
      this.month = Number(newVal);
    },
    dayProps(newVal) {
      this.day = Number(newVal);
    },
  },
};
</script>
